import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-laboratorio',
  standalone: true,
  imports: [],
  templateUrl: '../../movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-laboratorio.component.css'
})
export class HeroLaboratorioComponent {

  title = 'Laboratorio';
  subtitle1 = 'Resultados';
  subtitle2 = 'oportunos y exactos';
  callToAction = 'Contáctanos';
  routeImageMain = 'assets/img/laboratorio/imagenLaboratorio.svg';


}
